import { useNavigate } from "react-router-dom";
import ImageIcon from "@mui/icons-material/Image";
import SendIcon from "@mui/icons-material/Send";
import { Box } from "@mui/material";

interface Props {
  keyword: string;
  setKeyword: React.Dispatch<React.SetStateAction<string>>;
}

export default function SearchBar({ keyword, setKeyword }: Props) {
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!keyword.trim()) return;
    navigate(`/search-results?keyword=${encodeURIComponent(keyword)}`);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (!keyword.trim()) return;
      navigate(`/search-results?keyword=${encodeURIComponent(keyword)}`);
    }
  };

  return (
    <div className="w-full max-w-5xl mx-auto px-4">
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={(theme) => ({
          display: "flex",
          alignItems: "stretch",
          backgroundColor: "#fff",
          border: `3px solid ${theme.palette.primary.main}`, // ← #143282
          borderRadius: "20px",
          paddingX: 2,
          paddingY: 1.5,
          minHeight: 64,
          boxShadow: "0 12px 30px rgba(0,0,0,0.14)",
          gap: 2,
        })}
      >
        <textarea
          placeholder="お探しの商品を入力してください…"
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          onKeyDown={handleKeyDown}
          className="
            flex-1
            min-w-0
            text-lg
            placeholder:text-gray-400
            bg-transparent
            outline-none
            resize-none
            leading-snug
            overflow-hidden
          "
          style={{
            maxHeight: "6.5em",
          }}
        />

        <div className="flex items-center gap-2 flex-shrink-0">
          <button
            type="button"
            className="
              w-10 h-10
              rounded-full
              border border-gray-300
              flex items-center justify-center
              hover:bg-gray-100
              transition
            "
          >
            <ImageIcon fontSize="small" className="text-gray-500" />
          </button>

          <button
            type="submit"
            disabled={!keyword.trim()}
            className="
              w-10 h-10
              rounded-full
              bg-gray-600
              hover:bg-gray-700
              disabled:bg-gray-300
              flex items-center justify-center
              transition
            "
          >
            <SendIcon fontSize="small" className="text-white" />
          </button>
        </div>
      </Box>
    </div>
  );
}
